import React from 'react';
import UserLayout from '../../components/Layout/UserLayout';
import Layout from '../../components/Layout';
import InboxContainer from './InboxContainer';
import UnderConstruction from '../../components_new/UnderConstruction';
import { trackPageView } from '../../core/analytics.js';

const title = 'Inbox';

export default {
  path: '/inbox/:threadId?',

  action({ store }) {
    // From Redux Store
    const isAuthenticated = store.getState().runtime.isAuthenticated;

    if (!isAuthenticated) {
      return { redirect: '/login' };
    }
    trackPageView('/inbox');

    return {
      title,
      component: (
        <UserLayout>
          <InboxContainer title={title} />
        </UserLayout>
      ),
      // component: (
      //   <Layout>
      //     <UnderConstruction comment="Messaging will be available soon!" />
      //   </Layout>
      // ),
    };
  },
};



// WEBPACK FOOTER //
// ./src/routes/inbox/index.js